module.exports = __webpack_public_path__ + "img/intro.fe2a855b.jpg";